import { createApp } from 'vue';
import App from './App.vue';
import milligram from 'milligram';
createApp(App).use(milligram).mount('#app');
